function openTab(evt, tabName) {
   // Hide all tab content
   var i, tabContent, tabLinks;
   tabContent = document.getElementsByClassName("tab-content");
   for (i = 0; i < tabContent.length; i++) {
      tabContent[i].style.display = "none";
   }

   // Remove "active" class from all tab links
   tabLinks = document.getElementsByClassName("tab-link");
   for (i = 0; i < tabLinks.length; i++) {
      tabLinks[i].className = tabLinks[i].className.replace(" active", "");
   }

   // Show the current tab and add "active" class to the clicked tab
   document.getElementById(tabName).style.display = "block";
   evt.currentTarget.className += " active";
}
